// extracted by mini-css-extract-plugin
export default {"collapsableTitle":"ProfileInfo_collapsableTitle__N8Hb6","title":"ProfileInfo_title__jMRSQ","formContent":"ProfileInfo_formContent__Dea4k"};